//请自行添加语言资源
const reshipSku = {
  plantCode:'基地编码',
  plantName:"基地名称",
  skuNo:"品种编码",
  skuName:"品种名称",
  goodsTypeNo:"货物类型编码",
  goodsTypeName: "货物类型名称",
  msg:{

  }
};
export default reshipSku



// WEBPACK FOOTER //
// ./src/page/md/reshipSku/lang/reshipSku.zh.js